import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';

import { I18NService } from '@ebw-monorepo/i18n-translate';
import { UserGroupListItem, UserPermissionListItem, UserProfileConfig } from '../models/config-user-profile.model';
import { UserProfileService } from '../services/user-profile.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
@Component({
  selector: 'ebw-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit, AfterViewInit {
  public user: UserProfileConfig | null = null;
  public displayedColumns: string[] = ['name'];
  public displayedPermessionColumns: string[] = ['name', 'description'];
  public welcomeMessage: string = '';
  public userPermissionSource!: MatTableDataSource<any>;
  public userGroupSource!: MatTableDataSource<any>;
  public pageSize = 8;

  @ViewChild('permissionPaginator') permissionPaginator!: MatPaginator;
  @ViewChild('groupPaginator') permissionGroup!: MatPaginator;

  constructor(private userProfileService: UserProfileService, private translateService: I18NService) {}

  public ngOnInit(): void {
    this.welcomeMessage = this.translateService.getTranslateParameter('portale_web.profile.welcome_message');

    this.userProfileService.userData$.subscribe((res) => {
      this.user = res;
      if (this.user) {
        this.userPermissionSource = new MatTableDataSource<UserPermissionListItem>(this.user.permissions);

        this.userGroupSource = new MatTableDataSource<UserGroupListItem>(this.user.groups);
      }
    });
  }

  public ngAfterViewInit() {
    this.userPermissionSource.paginator = this.permissionPaginator;
  }
}
